// GENERATED FILE - DO NOT MODIFY
export enum ProcoreSynchronizationStatus {
    Success = 1,
    Failure = 2,
}

export let nameof = "ProcoreSynchronizationStatus";
